import * as moment from 'moment';
import { useMemo } from 'react';
import { IPreSelectHistoryDetails } from '@nkr/models/index';
import { AgGridReact } from 'ag-grid-react';
import { ColDef, FirstDataRenderedEvent, GridReadyEvent, ICellRendererParams, IHeaderParams } from 'ag-grid-community';
import { GridWrapper } from './styles';
import SortableHeaderComponent from '@nkr/views/admin/center/list/common/sortable-header';

interface IProps {
    data: IPreSelectHistoryDetails[],
    height: string,
    onGridReady: (e: GridReadyEvent) => void,
    onFirstDataRendered: (e: FirstDataRenderedEvent) => void
}

const CenterDetailsGrid = (props: IProps) => {
    const columns: ColDef[] = [
        {
            headerName: 'Date',
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>Date</SortableHeaderComponent>,
            field: 'preSelectAverageDate',
            headerClass: 'center-list-header',
            cellClass: 'center-list-cell',
            width: 200,
            cellRendererFramework: (props: ICellRendererParams) => {
                return <span>{moment(props.data.preSelectAverageDate).format('MM-DD-YYYY')}</span>
            }
        },

        {
            headerName: 'Percentage',
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>Percentage</SortableHeaderComponent>,
            headerClass: 'center-list-header',
            cellClass: 'center-list-cell',
            field: 'percentPreSelected',
            width: 250,
            cellRendererFramework: (params: ICellRendererParams) => {
                let data = params.data as IPreSelectHistoryDetails;

                if (data.percentPreSelected == -1) {
                    return <>N/A</>
                }

                return <>{data.percentPreSelected}</>
            }
        }
    ];

    const columnDefs = useMemo(() => columns, []);

    return (
        <GridWrapper className='ag-theme-bootstrap' style={{ height: props.height }}>
            <AgGridReact
                columnDefs={columnDefs}
                rowData={props.data}
                // headerHeight={30}
                suppressCellSelection={true}
                rowSelection='single'
                suppressHorizontalScroll={true}
                onGridReady={props.onGridReady}
                onFirstDataRendered={props.onFirstDataRendered}
                noRowsOverlayComponentFramework={params =>
                    <>
                        {props.data.length == 0 && (
                            <>No records found...</>
                        )}
                    </>
                }
                getRowStyle={(props: any) => {
                    let data = props.data as IPreSelectHistoryDetails;

                    if (data.isLowestScore) {
                        return { backgroundColor: 'yellow', fontWeight: 700 } as any;
                    }
                }}
            />
        </GridWrapper>
    );
}

export default CenterDetailsGrid;